module.exports = __webpack_public_path__ + "img/logo.27c2a19c.png";